export const calcNotAllocatedPallets = (stockItem) => {
  return (
    stockItem.boxUnit.unitsPerPallet &&
    stockItem.boxUnit &&
    Math.floor(stockItem.packedBoxesCount / stockItem.boxUnit.unitsPerPallet, 0)
  );
};
